module.exports = __webpack_public_path__ + "img/login02a.7e14b34e.png";